/* eslint-disable quotes */
import { defineComponent, h } from "vue";
import { Modal } from '@phi/components';

const body = `<div id="domagichtml">...</div>

<p><button type="button" class="btn btn--primary" onclick="domagic()">Go</button></p>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Modal, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            id: 'doMagicModal',
            title: 'Do Magic',
            unload: false,
        }, {
            body: () => h('div', { innerHTML: body }),
            footer: () => h('button', {
                class: 'btn',
                onClick: () => this.$emit('update:show', false),
            }, 'Close'),
        });
    }
});
